export default __webpack_public_path__ + "static/media/Spooky.4a67c288.pdf";